﻿$.fn.dxCtrlAssistantHtmlEmail = function custom_dxCtrlAssistantHtmlEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlassistanthtmlemail dx-ctrl");
        this.createInstance(new cdxCtrlAssistantHtmlEmail(this, option));
    }
    return this;
}

window.cdxCtrlAssistantHtmlEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.isFormulaire == 'undefined') option.isFormulaire = false

    var isDirtyTest = false
    var isDirtyMiseEnPage = false
    this.isDirty = function (value) {
        if (typeof value != 'undefined') {
            isDirtyTest = value
            isDirtyMiseEnPage = value
        }
        return ((dxBuilder) ? dxBuilder.isDirty(value) : false) || isDirtyTest || isDirtyMiseEnPage
    }

    var idTestAcid = ""
    var dxBuilder = null
    function mConstruit() {
        container.empty()
        var $DivTot = $("<div style='width:100%;height:100%;'/>").appendTo(container)
        mRempli($DivTot)
        idTestAcid = option.idTestAcid
    }

    this.isInit = false
    function mRempli(contentElement) {
        isDirtyTest = false
        isDirtyMiseEnPage = false
        contentElement.empty()
        contentElement.css("position", "relative")

        var $DivDetail = $("<div style='height:100%;width:100%;position:absolute;'/>").appendTo(contentElement)
        if (option.html.contains('<html lang="fr" assistant="1"><head>')) {
            //dxBuilder = $("<div style='height:100%;'/>").appendTo($DivDetail).dxCtrlBuilderEmail({
            //    bddCtrl: option.bddCtrl,
            //    urlHtml: option.urlHtml,
            //    html: option.html,
            //    onContentReady: function () {
            //        if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)
            //    }
            //}).dxCtrlBuilderEmail("instance")
        } else {
            //dxBuilder = $("<div style='height:100%;'/>").appendTo($DivDetail).dxCtrlConstructEmail({
            //    bddCtrl: option.bddCtrl,
            //    //urlHtml: option.urlHtml,          
            //    onDemandeTag: function () { option.onDemandeTag(Me) },
            //    html: option.html,
            //    lstfileheberge: option.lstfileheberge,
            //    onContentReady: function () {
            //        if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)
            //    }
            //}).dxCtrlConstructEmail("instance")
            dxBuilder = $("<div style='height:100%;'/>").appendTo($DivDetail).dxCtrlBuilderEmail({
                bddCtrl: option.bddCtrl,
                //urlHtml: option.urlHtml,     
                dxBtUndo: option.dxBtUndo,
                dxBtRedo: option.dxBtRedo,
                onDemandeTag: function () { option.onDemandeTag(Me) },
                onDemandeUrl: option.onDemandeUrl,
                html: option.html,
                isFormulaire: option.isFormulaire,
                onValueChangedDevexpress:option.onValueChangedDevexpress,
                onDemandeIdComEmailEnvoi: option.onDemandeIdComEmailEnvoi,
                onDeclencheSaveAuto: option.onDeclencheSaveAuto,
                idTestAcid: (option.dataHtml ? option.dataHtml.idTestAcid : ""),
                dateTestAcid: (option.dataHtml ? option.dataHtml.dateTestAcid : null),
                lstfileheberge: (option.dataHtml ? option.dataHtml.lstfileheberge : []),
                onNewTest: function (idTest) {
                    option.onNewTest(idTest)
                },
                onContentReady: function () {
                    if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)
                    window.setTimeout(function () { Me.isInit = true },0)
                }
            }).dxCtrlBuilderEmail("instance")
        }

        $DivPreviEmail = $("<div style='width:100%;height:100%;position:absolute;display:none'>previ email</div>").appendTo(contentElement)

    }

    this.mTitre = function (value) {
        return dxBuilder.mTitre(value)
    }
    this.mNom = function (value) {
        return dxBuilder.mNom(value)
    }

    this.getCurrentEditorHtml = function () { return dxBuilder.getCurrentEditorHtml() }

    //var $DivPreviEmail = null
    //function mShowPrevi() {
    //    if (!$DivPreviEmail.is(":visible")) {
    //        dxBuilder.element().fadeOut(200)
    //        $DivPreviEmail.empty()
    //        $DivPreviEmail.fadeIn(200)
    //        $("<div style='width:100%;height:100%;'/>").appendTo($DivPreviEmail).dxCtrlEmailPrevisualisationAcid({
    //            bddCtrl: option.bddCtrl,
    //            data: option.data,
    //            onDemandeObjet: option.onDemandeObjet,
    //            onDemandeHtml: option.onDemandeHtml,
    //            onDemandeUrl: option.onDemandeUrl,
    //            idTestAcid: option.idTestAcid,
    //            dateTestAcid: option.dateTestAcid,
    //            onNewTest: function (idTest) {
    //                isDirtyTest = true
    //                idTestAcid = idTest
    //            },
    //            html: Me.mGetHtml(),
    //            onClose: function () {
    //                mShowBuilder()
    //                dxBuilder.mHidePrevisualisation()
    //                dxBuilder.mModeConception()
    //            }
    //        })
    //    }
    //}

    this.mGetIdTestAcid = function () { return idTestAcid }

    function mShowBuilder() {
        if (!dxBuilder.element().is(":visible")) {
            $DivPreviEmail.fadeOut(200)
            dxBuilder.element().fadeIn(200)
        }
    }

    this.mGetHtml = function () { return dxBuilder.mGetHtml() }
    this.mSetHtml = function (html, funcFin) {
        option.bddCtrl.mAjaxCall({ command: "generedataassistanthtml", html: html }, function (data) {
            option.urlHtml = data.urlhtml
            option.html = data.html
            if (typeof funcFin != "undefined" && funcFin != null) option.onContentReady = function () { funcFin() }
            mConstruit()
        })
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}